import type { SupportedLocale } from "staticConfiguration";
import type {
  QuickLinkWidgetFormValues,
  QuickLinkWidgetSettingsDto,
  SelectedQuickLink,
} from "./QuickLinkDefs";

export function mapQuickLinkWidgetSettingsToFormValues(
  dto: QuickLinkWidgetSettingsDto,
  currentLocale: SupportedLocale
): QuickLinkWidgetFormValues | undefined {
  const sortedLinks = [...(dto.quickLinks ?? [])].sort(
    (a, b) => (a.order ?? 0) - (b.order ?? 0)
  );
  return {
    isEnabled: Boolean(dto.enabled),
    currentTab: "DocNode",
    selectedQuickLinks:
      sortedLinks
        .map((ql): SelectedQuickLink | undefined => {
          if (ql.type === "DocNode" && ql.docNodePath) {
            return {
              id: ql.docNodePath,
              type: "DocNode",
            };
          }
          if (ql.type === "CustomLink" && ql.customLink) {
            return {
              id: ql.customLink.id ?? crypto.randomUUID(),
              type: "CustomLink",
              customLink: {
                currentLocaleTab: currentLocale,
                translations:
                  ql.customLink.translations?.map((tr) => ({
                    locale: tr.locale ?? currentLocale,
                    name: tr.name ?? "",
                    url: tr.url ?? "",
                  })) ?? [],
              },
            };
          }
          return undefined;
        })
        .filter((ql): ql is SelectedQuickLink => ql !== undefined) ?? [],
    quickLinkOrder: sortedLinks
      .map((link) => {
        if (link.type === "DocNode") {
          return link.docNodePath;
        }
        if (link.type === "CustomLink") {
          return link.customLink?.id;
        }
        return undefined;
      })
      .filter((id): id is string => typeof id === "string"),
  };
}
